import { baseApi } from 'shared/api/baseApi'

import {
    COMPETITION_TABLE_STATS_TAG,
    PHASES_TAG,
    SPORTS_TAG,
    SPORT_TAG,
} from 'shared/api/tags'
import type { RequestSportGenerateUploadURL, Sport } from '../model/types'

export interface SportParams {
    status?: string
    id: string
}

export const sportsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSports: build.query<Sport[], RequestBasicParams>({
            query: (params) => ({
                url: `sports`,
                method: 'GET',
                params: params,
            }),
            providesTags: [SPORTS_TAG],

            // serializeQueryArgs: ({ endpointName }) => {
            //     return endpointName
            // },

            // // Refetch when the page arg changes
            // forceRefetch({ currentArg, previousArg }) {
            //     return currentArg !== previousArg
            // },
        }),

        getSport: build.query<Sport, SportParams>({
            query: ({ id, status }) => ({
                url: `sports/${id}`,
                method: 'GET',
                params: { status },
            }),
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },

            // Refetch when the page arg changes
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg
            },
            providesTags: [SPORT_TAG],
        }),

        editSport: build.mutation<Sport, Partial<Sport>>({
            query: ({ id, ...body }) => ({
                url: `sports/${id}`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: [
                SPORTS_TAG,
                SPORT_TAG,
                COMPETITION_TABLE_STATS_TAG,
                PHASES_TAG,
            ],
        }),

        addNewSport: build.mutation<ApiResponse<Sport>, Sport>({
            query: (body) => ({
                url: `sports`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: [
                SPORTS_TAG,
                COMPETITION_TABLE_STATS_TAG,
                PHASES_TAG,
            ],
        }),

        generateUploadUrl: build.mutation<
            ApiResponse<string>,
            RequestSportGenerateUploadURL
        >({
            query: (body) => ({
                url: `sports/${body.sportId}/field-photo/generate-upload-url`,
                method: 'POST',
            }),
            invalidatesTags: [SPORT_TAG, SPORTS_TAG],
        }),

        uploadFieldPhoto: build.mutation<
            ApiResponse<Sport>,
            RequestSportGenerateUploadURL
        >({
            query: (body) => ({
                url: `sports/${body.sportId}/field-photo`,
                method: 'POST',
                body: { key: body.key },
            }),

            invalidatesTags: [SPORT_TAG, SPORTS_TAG],
        }),
    }),
})

export const {
    useGetSportsQuery,
    useAddNewSportMutation,
    useEditSportMutation,
    useGenerateUploadUrlMutation,
    useUploadFieldPhotoMutation,
    useGetSportQuery,
} = sportsApi
